import { Component } from '@angular/core';

@Component({
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass'],
})
export class UserComponent {}
